exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.scroll-area[data-v-1c78a744] {\n  position: relative;\n  margin: auto;\n  width: 100%;\n  height: 100%;\n}\n.accordion[data-v-1c78a744] {\n  max-height: 100%;\n  transition: 0.3s ease all;\n}\n.is-closed .accordion[data-v-1c78a744] {\n  max-height: 0;\n}\n", ""]);

// exports
